module.exports = "New note"